import React from 'react';

export default function AccessCaptableContent(props: { captableLink: string }) {
  const { captableLink } = props;

  return (
    <div>
      <a href={captableLink} title="Access Cap Table">
        <img
          className="svg-dark-invert"
          src="/static/icons/icon_external_link.svg"
          alt="Captable"
        />
      </a>
    </div>
  );
}
